import { api, tagTypes } from "./api";

export interface CurrencyConversionParams {
	destinationCurrency: string;
	sourceCurrency: string;
	amount: number;
}

export interface CurrencyConversionResponse {
  success: boolean;
  message: string;
  payload: {
    from: string;
    to: string;
    amount: number;
    convertedAmount: number;
    rate: number;
  };
}


// Inject currency endpoints into the main API
export const currencyApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// Get currency conversion details
		getCurrencyDetails: builder.query<
			CurrencyConversionResponse,
			CurrencyConversionParams
		>({
			query: ({ sourceCurrency, destinationCurrency, amount }) => ({
				// url: `booking/v1/admin/currency_detail?includeExchange=true&destinationCurrency=${destinationCurrency}&amount=${amount}`,
				url: `booking/v1/admin/convert_currency?sourceCurrency=${sourceCurrency}&destinationCurrency=${destinationCurrency}&amount=${amount}`,
				method: "GET",
			}),
			providesTags: [tagTypes.Booking],
		}),

		// Get available currencies (if you have an endpoint for this)
		getAvailableCurrencies: builder.query<any, void>({
			query: () => ({
				url: "booking/v1/admin/currencies",
				method: "GET",
			}),
			providesTags: [tagTypes.Booking],
		}),
	}),
});

export const {
	useGetCurrencyDetailsQuery,
	useLazyGetCurrencyDetailsQuery,
	useGetAvailableCurrenciesQuery,
} = currencyApi;
